import { IconProps } from "@/components/web/icons/types";
import { cn } from "@/lib/utils";

const Check: React.FC<IconProps> = ({ color = "#FFFFFF", className, width = "80", height = "80" }) => {
    return (
        <div>
            <svg
                width={width}
                height={height}
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
            >
                <rect
                    x="3.39539"
                    y="3.39539"
                    width="73.2092"
                    height="73.2092"
                    rx="36.6046"
                    stroke={color}
                    stroke-width="6.79078"
                />
                <path
                    d="M56.6771 27.5013L33.7604 50.4179L23.3438 40.0013"
                    stroke={color}
                    stroke-width="6.79078"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    );
};

export default Check;
